import * as React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { asSnake } from '../../../shared/string';

export interface SelectTextField {
    id?: string,
    options: string[],
    disabled?: boolean,
    className?: string,
    style?: React.CSSProperties,
    inputStyle?: React.CSSProperties,
    label?: string,
    value?: string,
    allowUndefined?: boolean,
    variant?: 'outlined' | 'standard' | 'filled',
    onValueChanged?: (values: string) => void,
}

export const SelectTextField: React.FC<SelectTextField> = (props) => {
    const {
        id,
        value,
        label,
        onValueChanged,
        options = [],
        disabled,
        className,
        style,
        inputStyle,
        allowUndefined,
        variant = 'outlined',
    } = props;

    const labelId = label && id ? `${id}-label` : undefined;

    return (
        <FormControl fullWidth size="small" className={className} style={style}>
            {label && <InputLabel id={labelId} variant={variant}>{label}</InputLabel>}
            <Select
                id={id ? `${id}-input` : undefined}
                labelId={labelId}
                disabled={disabled}
                value={value || ''}
                label={variant !== 'standard' ? label : undefined}
                onChange={e => onValueChanged && onValueChanged(e.target.value)}
                variant={variant}
                inputProps={{ style: inputStyle }}
            >
                {allowUndefined !== false ? (
                    <MenuItem id={id ? `${id}-undefined-option` : undefined} value="">
                        <em>None</em>
                    </MenuItem>
                ) : undefined}
                {options.map(o => (
                    <MenuItem
                        id={id ? `${id}-${asSnake(o)}-option` : undefined}
                        key={o}
                        value={o}
                    >
                        {o}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}